"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.UserActions = void 0;
var UserActions;
exports.UserActions = UserActions;

(function (UserActions) {
  UserActions["showMe"] = "@app/user/show";
  UserActions["logOut"] = "@app/user/logOut";
  UserActions["getMyUserRequest"] = "@app/user/auth";
  UserActions["getMyUserLoginRequired"] = "@app/user/auth/login-required";
  UserActions["getMyImageRequest"] = "@app/user/image";
  UserActions["getFlights"] = "@app/user/flights";
  UserActions["getMyImageResponse"] = "@app/user/image/success";
  UserActions["getMyImageFailed"] = "@app/user/image/failed";
  UserActions["getMyOrganizations"] = "@app/user/organizations";
  UserActions["getMyOrganizationsResponse"] = "@app/user/organizations/success";
  UserActions["getMyOrganizationsFailed"] = "@app/user/organizations/failed";
  UserActions["getMyCurrentOrganization"] = "@app/user/current-organization";
  UserActions["getMyCurrentOrganizationResponse"] = "@app/user/current-organization/success";
  UserActions["getMyCurrentOrganizationFailed"] = "@app/user/current-organization/failed";
  UserActions["getFlightsResponse"] = "@app/user/flights/success";
  UserActions["getFlightsFailed"] = "@app/user/flights/failed";
  UserActions["showTenantPicker"] = "@app/user/tenant/show-picker";
  UserActions["changeTenant"] = "@app/user/tenant/change";
  UserActions["getUser"] = "@app/user/me";
  UserActions["getUserResponse"] = "@app/user/me/success";
  UserActions["getUserFailed"] = "@app/user/me/failed";
  UserActions["updateUserImage"] = "user/update-user-image";
})(UserActions || (exports.UserActions = UserActions = {}));